import{RP_GAS_COMPOSITION_MODEL_LIST, RP_GAS_COMPOSITION_PAGINATION, RP_GAS_COMPOSITION_SEARCH}from './actionType'

export const setModelDeviceListToState = (payload) => ({
    type: RP_GAS_COMPOSITION_MODEL_LIST,
    payload
})

export const setSearchToState = (payload) => ({
    type: RP_GAS_COMPOSITION_SEARCH,
    payload
})
export const setPaginationToState = (payload) => ({
    type: RP_GAS_COMPOSITION_PAGINATION,
    payload
})

